const metaBuyingCompanies: string[] = [
  "blisspoint",
  "butcherbox",
  "bonafidehealth",
  "onceuponafarm",
  "greenpan",
  "maurices",
  "brackish",
  "fishersfinery",
  "nobull",
  "instacartshoppers",
  "byheart",
  "vici",
  "corepoweryoga",
  "easypeasy",
  "stjohnknits",
  "warbyparker",
  "saxx",
  "dsw",
  "eddiebauer",
  "amiri",
  "jachsny",
  "piloti",
  "ethanallen",
];

export const shouldEnableMetaBuying = (company: string): boolean => {
  return metaBuyingCompanies.includes(company);
};
